import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

function MobileMenu({ isOpen, onClose }) {
  const [activeMenu, setActiveMenu] = useState(null);
  const [activeShopMenu, setActiveShopMenu] = useState(false); // Shop submenu state
  const menuRefs = useRef({});

  // Toggle dropdown menu
  const toggleMenu = (index) => {
    if (index !== 6) {
      setActiveMenu(activeMenu === index ? null : index);
    }
  };

  // Handle Shop menu separately
  const toggleShopMenu = (e) => {
    e.stopPropagation(); // Prevent menu from closing
    setActiveShopMenu(!activeShopMenu);
  };

  // Apply height animation when activeMenu changes
  useEffect(() => {
    Object.keys(menuRefs.current).forEach((key) => {
      const submenu = menuRefs.current[key];
      if (submenu) {
        submenu.style.height =
          activeMenu == key ? `${submenu.scrollHeight}px` : "0px";
      }
    });
  }, [activeMenu]);

  return (
    <div
      className={`th-menu-wrapper onepage-nav ${
        isOpen ? "th-body-visible" : ""
      }`}
      style={{ visibility: isOpen ? "visible" : "hidden" }}
    >
      <div className="th-menu-area text-center">
        <button className="th-menu-toggle" onClick={onClose} aria-label="Close">
          <i className="fal fa-times" />
        </button>

        <div className="mobile-logo">
          <Link to="/">
            <img src="/assets/img/logo2.svg" alt="Tourm" />
          </Link>
        </div>

        <div className="th-mobile-menu">
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>

            <li>
              <Link to="/about">About Us</Link>
            </li>

            <li>
              <Link to="/contact">Our Printers</Link>
            </li>

            <li>
              <Link to="/contact">Our Accessories</Link>
            </li>
            <li>
              <Link to="/contact">Office Printers</Link>
            </li>
            <li>
              <Link to="/contact">Home Printers</Link>
            </li>

            <li>
              <Link to="/contact">Contact Us</Link>
            </li>

            <li>
              <Link to="/contact">Log In</Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default MobileMenu;
